import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@creanizer/ui'
import { BulkDataManager } from '../../features/settings/components/BulkDataManager'

interface BulkDataModalProps {
  isOpen: boolean
  onClose: () => void
}

export function BulkDataModal({ isOpen, onClose }: BulkDataModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-4xl max-h-[90vh] overflow-y-auto" 
        style={{ backgroundColor: 'white' }}
      >
        <DialogHeader>
          <DialogTitle>一括データ管理</DialogTitle>
        </DialogHeader>
        <BulkDataManager />
      </DialogContent>
    </Dialog>
  )
}